<template>
    <div v-if="form">
        <div class="flex justify-between items-center mb-3">
            <h2 class="text-xl text-gray-800">Basic Details</h2>
        </div>
        <div class="bg-white shadow-lg p-6 rounded-lg border border-gray-300">
            <div>
                <alert v-show="is_profile_incomplete" class="mb-6 text-sm" type="info" closable>
                    <p class="font-bold">Complete your profile</p>
                    <p>
                        Your profile won't show up on YaganKar website publicily until you don't complete basic details (title,
                        years of experience, hourly rate) of your profile.
                    </p>
                </alert>
                <my-select
                    v-model="profile_visibility"
                    name="is_public"
                    :error="form.errors.get('is_public')"
                    label="Profile Visibility"
                    class="mb-4"
                    :options="{ everyone: 'Everyone', only_me: 'Only me' }"
                />

                <my-input
                    v-model="form.title"
                    name="title"
                    :error="form.errors.get('title')"
                    label="Current Title"
                    class="mb-4"
                    placeholder="e.g. Software Developer"
                />

                <my-select
                    v-model="form.location"
                    name="location"
                    :error="form.errors.get('location')"
                    label="Location"
                    :options="countries"
                    class="mb-4"
                    placeholder="Choose a country"
                />

                <my-select
                    v-if="authUser().user_type !== 'company'"
                    v-model="form.gender"
                    name="gender"
                    :error="form.errors.get('gender')"
                    label="Gender"
                    :options="{ 0: 'Female', 1: 'Male' }"
                    class="mb-4"
                    placeholder="Choose your gender"
                />

                <my-input
                    v-model="form.years_of_experience"
                    name="years_of_experience"
                    :error="form.errors.get('years_of_experience')"
                    label="Years of Experience"
                    class="mb-4"
                    placeholder="e.g. 5"
                />

                <my-input
                    v-model="form.hourly_rate"
                    name="hourly_rate"
                    :error="form.errors.get('hourly_rate')"
                    label="Rate Per Hour (in US Dollars)"
                    class="mb-4"
                    placeholder="e.g. 20"
                />

                <my-multiselect
                    v-model="form.tags"
                    :options="allTags"
                    name="tags"
                    label-by="name.en"
                    :error="form.errors.get('tags')"
                    label="Skills"
                    class="mb-4"
                    placeholder="e.g. Software Development, UX Design, etc"
                />

                <my-textarea
                    v-model="form.bio"
                    name="bio"
                    :error="form.errors.get('bio')"
                    label="Brief Bio"
                    class="mb-4 h-48"
                    placeholder="Your brief bio (not more than 500 characters)"
                />

                <hr class="my-4" />
                <div class="flex justify-between">
                    <div></div>
                    <my-button :loading="submitting" class="btn btn-primary" @click="submitForm">
                        <i class="fa fa-save"></i> Update Details
                    </my-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '../forms/form';

export default {
    props: {
        userId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            profile_visibility: null,
            form: null,
            profile: null,
            allTags: [],
            submitting: false,
            countries: []
        };
    },

    computed: {
        is_profile_incomplete: function() {
            return !this.profile.title || !this.profile.years_of_experience || !this.profile.hourly_rate;
        }
    },

    watch: {
        'form.is_public': function(newVal) {
            this.profile_visibility = newVal ? 'everyone' : 'only_me';
        },

        profile_visibility: function(newVal) {
            this.form.is_public = newVal === 'everyone' ? true : false;
        }
    },

    mounted() {
        this.fetchAllSkills();
        this.fetchCountries();

        axios.get(`/api/users/${this.userId}/profile`).then(response => {
            this.profile = response.data.data;

            this.initForm();
        });
    },

    methods: {
        initForm() {
            this.form = new Form({
                is_public: this.profile.is_public,
                title: this.profile.title,
                years_of_experience: this.profile.years_of_experience,
                location: this.profile.location,
                bio: this.profile.bio,
                hourly_rate: this.profile.hourly_rate,
                tags: this.profile.tags,
                gender: this.authUser().user_type !== 'company' ? this.profile.gender : null
            });
        },

        fetchAllSkills() {
            axios.get(`/api/tags`).then(response => {
                this.allTags = response.data.data;
            });
        },

        fetchCountries() {
            axios.get('/api/countries').then(response => {
                this.countries = _.keyBy(response.data.data, value => value);
            });
        },

        submitForm() {
            this.submitting = true;

            this.form
                .post(`/api/profile/${this.profile.id}`)
                .then(response => {
                    this.profile = response.data.data;
                    flash.success();
                    this.submitting = false;
                })
                .catch(() => {
                    flash.error();
                    this.submitting = false;
                })
                .finally(() => (this.submitting = false));
        }
    }
};
</script>
